import React, { useEffect } from "react";
import { gameCollectionArray, userLevelArray } from "../Globals/globalMetaData";
import { toast } from "react-toastify";
import { generalPatchFunction, generalPostFunction } from "../Globals/globalFunctions";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import FormError from "../Components/FormError";
import { requiredValidator } from "../Components/FormValidations";
import { useSelector } from "react-redux";
import { SvgIcon } from "../Components/SvgIcons";

function AccountEdit() {
	const navigate = useNavigate();
	const {
		register,
		formState: { errors },
		handleSubmit,
		reset,
		watch,
		setValue,
	} = useForm();

	const locationState = useLocation().state;
	const account = JSON.parse(localStorage.getItem("account"));
	const setAllPlayers = useSelector((state) => state.allPlayers.setAllPlayers);

	useEffect(() => {
		const data = locationState || {};
		reset(data);
	}, [locationState]);

	const editAccount = async (data) => {
		const preparedData = {
			...data,
			games: JSON.stringify(data?.games),
			devices: JSON.stringify(data?.devices),
		};
		try {
			const response = await generalPostFunction("/updateuser", preparedData, "3040");

			if (response.message) {
				toast.success("Account edit successfully!");
				reset(data);
			} else {
				toast.error("Account edit failed");
			}
		} catch (err) {
			console.log(err);
		}
	};

	return (
		<div className="overviewTableWrapper">
			<div className="overviewTableChild">
				<div className="d-flex flex-wrap">
					<div className="col-12">
						<div className="heading">
							<div className="content">
								<h4>Account Edit</h4>
								<p>Edit a new account</p>
							</div>
							<div className="buttonGroup">
								<button className="panelButton gray" onClick={() => navigate(-1)}>
									<span className="text">Back</span>
									<span className="icon">
										<SvgIcon name="back" />
									</span>
								</button>
								<button type="button" className="panelButton" onClick={handleSubmit(editAccount)}>
									<span className="text">Save</span>
									<span className="icon">
										<SvgIcon name="save" />
									</span>
								</button>
							</div>
						</div>
					</div>
					<div className="col-12" style={{ padding: "25px 23px" }}>
						<form className="mb-0" onSubmit={handleSubmit(editAccount)}>
							{watch().level > 1 && (
								<div className="formRow col-xl-6">
									<div className="formLabel">
										<label>Select Super Stockist</label>
									</div>
									<div className="col-6">
										{/* <input className="formItem" type="text" value={setAllPlayers.find((item) => item.id == watch().super_stockist_id)?.username} disabled /> */}
										<select className="formItem" disabled>
											<option value={""}>{watch().super_stockist_id ?? "No Super Stockist"}</option>
										</select>
										{errors.super_stokez && <FormError message={errors.level.message} />}
									</div>
								</div>
							)}
							{watch().level > 2 && (
								<div className="formRow col-xl-6">
									<div className="formLabel">
										<label>Select Stockist</label>
									</div>
									<div className="col-6">
										{/* <input className="formItem" type="text" value={setAllPlayers.find((item) => item.id == watch().stockist_id)?.username} disabled /> */}
										<select className="formItem" disabled>
											<option value={""}>{watch().stockist_id ?? "No Stockist"}</option>
										</select>
										{errors.stokez && <FormError message={errors.stokez.message} />}
									</div>
								</div>
							)}
							{watch().level > 3 && (
								<div className="formRow col-xl-6">
									<div className="formLabel">
										<label>Select Master</label>
									</div>
									<div className="col-6">
										{/* <input className="formItem" type="text" value={setAllPlayers.find((item) => item.id == watch().master_id)?.username} disabled /> */}
										<select className="formItem" disabled>
											<option value={""}>{watch().master_id ?? "No Master"}</option>
										</select>
										{errors.master && <FormError message={errors.master.message} />}
									</div>
								</div>
							)}
							{watch().level > 4 && (
								<>
									<div className="formRow col-xl-6">
										<div className="formLabel">
											<label>Select Agent</label>
										</div>
										<div className="col-6">
											{/* <input className="formItem" type="text" value={setAllPlayers.find((item) => item.id == watch().agent_id)?.username} disabled /> */}
											<select className="formItem" disabled>
												<option value={""}>{watch().agent_id ?? "No Agent"}</option>
											</select>
											{errors.agent && <FormError message={errors.agent.message} />}
										</div>
									</div>
									<div className="border-top" />
								</>
							)}
							<div className="formRow col-xl-6">
								<div className="formLabel">
									<label>Username</label>
								</div>
								<div className="col-6">
									<input className="formItem" type="text" defaultValue={""} {...register("username", requiredValidator)} disabled />
									{errors.username && <FormError message={errors.username.message} />}
								</div>
							</div>
							<div className="formRow col-xl-6">
								<div className="formLabel">
									<label>Password</label>
								</div>
								<div className="col-6">
									<input className="formItem" type="text" defaultValue={"123456"} {...register("password", requiredValidator)} />
									{errors.password && <FormError message={errors.password.message} />}
								</div>
							</div>
							<div className="formRow col-xl-6">
								<div className="formLabel">
									<label>Balance</label>
								</div>
								<div className="col-6">
									<input className="formItem" type="number" defaultValue={1000} {...register("balance")} disabled />
								</div>
							</div>
							<div className="formRow col-xl-6 d-none">
								<div className="formLabel">
									<label>Owner</label>
								</div>
								<div className="col-6">
									<input className="formItem" type="text" defaultValue={""} {...register("owner", requiredValidator)} disabled />
									{errors.owner && <FormError message={errors.owner.message} />}
								</div>
							</div>
							<div className="formRow col-xl-6">
								<div className="formLabel">
									<label>Commission %</label>
								</div>
								<div className="col-6">
									<input className="formItem" type="number" defaultValue={5} min={0} max={100} {...register("discount")} />
									{errors.discount && <FormError message={errors.discount.message} />}
								</div>
							</div>
							<div className="formRow col-xl-6">
								<div className="formLabel">
									<label>Level</label>
								</div>
								<div className="col-6">
									<select className="formItem" {...register("level", requiredValidator)} disabled>
										{userLevelArray
											.filter((item) => item.level !== account.level)
											.map((item, index) => (
												<option key={index} value={item.level}>
													{item.name}
												</option>
											))}
									</select>
									{errors.level && <FormError message={errors.level.message} />}
								</div>
							</div>
							{/* <div className="formRow col-xl-6">
								<div className="formLabel">
									<label>Status</label>
								</div>
								<div className="col-6">
									<select className="formItem" type="number" defaultValue={1} {...register("registerstate")}>
										<option value={1}>Enable</option>
										<option value={0}>Disable</option>
									</select>
									{errors.registerstate && <FormError message={errors.registerstate.message} />}
								</div>
							</div> */}
							{watch().level == userLevelArray.find((item) => item.name === "User")?.level && (
								<div className="formRow col-xl-6">
									<div className="col-6">
										<div className="formLabel">
											<label className="fw-bold">Games</label>
										</div>
										<ul>
											{console.log(watch()?.games)}
											{gameCollectionArray?.map((item) => {
												return (
													<li>
														<input type="checkbox" value={item.api} checked={watch()?.games?.includes(item.api)} {...register("games")} /> {item.label}
													</li>
												);
											})}
										</ul>
									</div>

									<div className="col-6">
										<div className="formLabel">
											<label className="fw-bold">Device Permissions</label>
										</div>
										<ul>
											<li>
												<input type="checkbox" value="pc" {...register("devices")} /> PC
											</li>
											<li>
												<input type="checkbox" value="mobile" {...register("devices")} /> Mobile
											</li>
											<li>
												<input type="checkbox" value="both" {...register("devices")} /> Both (PC + Mobile)
											</li>
										</ul>
									</div>
								</div>
							)}
						</form>
					</div>
				</div>
			</div>
		</div>
	);
}

export default AccountEdit;
